import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import requestUtils from 'api/requestUtils'

type Response = paths['/api/lux-loyalty/points/calculate-burn']['post']['responses']['200']['content']['application/json']
type Payload = paths['/api/lux-loyalty/points/calculate-burn']['post']['requestBody']['content']['application/json']

interface Options {
  customerId: string
}

async function requestLoyaltyPointsBurnCalculation(
  calculationRequests: Array<App.Checkout.LoyaltyPointBurnCalculationRequest>,
  {
    customerId,
  }: Options,
): Promise<App.LoyaltyPointBurnCalculation> {
  const payload: Payload = {
    customerId,
    itemDetails: calculationRequests.map<Utils.ArrayElement<Payload['itemDetails']>>((calcReq) => {
      return {
        currency: calcReq.currency,
        itemId: calcReq.item.itemId,
        price: calcReq.price,
        mx: calcReq.mx,
        loyaltyProductType: calcReq.productType,
        burnGroupKey: calcReq.loyaltyGroupKey,
      }
    }),
  }

  const response = await requestUtils.post<Response, Payload>(
    '/api/lux-loyalty/points/calculate-burn',
    payload,
    { credentials: 'include' },
  )

  const mapped: App.LoyaltyPointBurnCalculation = {
    minBurnablePoints: response.result.minPointsForPurchase ?? 0,
    maxBurnablePoints: response.result.maxPointsForPurchase ?? Infinity,
    items: response.result.itemDetails.map<App.LoyaltyItemPointBurnCalculation>((serverItem) => {
      return {
        itemId: serverItem.itemId,
        priceInPoints: serverItem.priceInPoints,
        priceInCurrency: serverItem.price,
        isRedeemableWithPoints: serverItem.isRedeemableWithPoints,
      }
    }),
  }

  return mapped
}

export default requestLoyaltyPointsBurnCalculation
